import { adminAndVerifiedGuard, adminOnlyGuard } from '@foundation/shared/access';
import { Route } from '@angular/router';

export function buildAdminRoute(additionalRoutes: Route[] = []): Route {
	return {
		path: 'admin',
		canMatch: [adminOnlyGuard],
		children: [
			{
				path: '',
				loadComponent: () => import('@foundation/admin/pages').then((m) => m.AdminDashboardComponent),
			},
			{
				path: 'translations',
				canMatch: [adminAndVerifiedGuard],
				loadComponent: () => import('@foundation/translations/pages').then((m) => m.TranslationListPageComponent),
			},
			{
				path: 'emails',
				canMatch: [adminAndVerifiedGuard],
				loadComponent: () => import('@foundation/admin/pages').then((m) => m.AdminEmailsPageComponent),
			},
			{
				path: 'tasks',
				canMatch: [adminAndVerifiedGuard],
				loadComponent: () => import('@foundation/admin/pages').then((m) => m.AdminTasksPageComponent),
			},
			{
				path: 'users',
				canMatch: [adminAndVerifiedGuard],
				loadComponent: () => import('@foundation/admin/pages').then((m) => m.AdminUsersPageComponent),
			},
			{
				path: 'tickets',
				canMatch: [adminAndVerifiedGuard],
				loadComponent: () => import('./admin-tickets-page/admin-tickets-page.component').then((m) => m.AdminTicketsPageComponent),
			},
			{
				path: 'users/:userId/builder',
				canMatch: [adminAndVerifiedGuard],
				loadComponent: () => import('@foundation/users/pages').then((m) => m.UserBuilderPageComponent),
			},
			{
				path: 'users/:userId/json',
				canMatch: [adminAndVerifiedGuard],
				loadComponent: () => import('@foundation/users/pages').then((m) => m.UserJsonPageComponent),
			},
			{
				path: 'feedback',
				canMatch: [adminAndVerifiedGuard],
				loadComponent: () => import('@foundation/feedback/ui').then((m) => m.FeedbackAdminPageComponent),
			},
			{
				path: 'assistant-tools',
				canMatch: [adminAndVerifiedGuard],
				loadComponent: () => import('@foundation/admin/pages').then((m) => m.AdminAssistantToolsPageComponent),
			},
			{
				path: 'cronjobs',
				canMatch: [adminAndVerifiedGuard],
				loadComponent: () => import('@foundation/admin/pages').then((m) => m.AdminCronjobsPageComponent),
			},
			...additionalRoutes,
			{
				path: '**',
				redirectTo: '',
			},
		],
		loadComponent: () => import('@foundation/admin/pages').then((m) => m.AdminShellComponent),
	};
}
